/**
 * Represents a parsed markdown link with its text and URL.
 */
export interface ParsedLink {
  text: string;
  url: string;
}

/**
 * Parses markdown links from a content string.
 * Matches the pattern [text](url) and extracts both components.
 *
 * @param {string} content - The content string containing markdown links.
 * @returns {ParsedLink[]} An array of parsed link objects.
 *
 * @example
 * const links = parseLinksFromMarkdown("Check [Google](https://google.com) and [GitHub](https://github.com)");
 * // Returns: [{ text: "Google", url: "https://google.com" }, { text: "GitHub", url: "https://github.com" }]
 */
export const parseLinksFromMarkdown = (content: string): ParsedLink[] => {
  const linkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
  const links: ParsedLink[] = [];
  let match;

  while ((match = linkRegex.exec(content)) !== null) {
    links.push({
      text: match[1],
      url: match[2],
    });
  }

  return links;
};
